import React from 'react';
import Styled from 'styled';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { fromGlobalId } from 'graphql-relay';
import { FormattedMessage, FormattedDate } from 'react-intl';

import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';

import userIcon from 'four-nets/icons/svg/icon_user.svg';
import heartIcon from 'four-nets/icons/svg/icon_heart.svg';
import realestateIcon from 'four-nets/icons/svg/icon_category-real-estate.svg';
import { HideForVendor } from 'four-nets/vendor/permissions';

import defaultStyles from './user-information.scss';
import AuthorSVGIcon from '../author-svg-icon/author-svg-icon';
import { UserInformationFragment } from './user-information.graphql';

export interface Props extends UserInformationFragment {
    styles: typeof defaultStyles;
}

function treatAsUTC(date: Date) {
    var result = new Date(date);
    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
    return result;
}

function daysBetween(startDate: Date) {
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const endDate = new Date();
    return Math.abs(Math.ceil(((treatAsUTC(endDate) as any) - (treatAsUTC(startDate) as any)) / millisecondsPerDay));
}

function UserInformation(props: Props) {
    const { styles, dateJoined, profile, photoBlog } = props;
    const county = profile && profile.county;
    const sex = profile && profile.sex;
    const weddingDate = photoBlog && photoBlog.details && ((photoBlog.details as any).weddingDate as string);

    return (
        <React.Fragment>
            <div className={styles.dateJoined}>
                <AuthorSVGIcon src={userIcon} />
                <FormattedMessage id='REGISTERED_IN_DATE' values={{ gender: sex === 2 ? 'male' : 'female' }} />
                &nbsp;
                <FormattedDateAgoView value={new Date(dateJoined)} />
            </div>
            {county ? (
                <HideForVendor>
                    <div className={styles.county}>
                        <AuthorSVGIcon src={realestateIcon} />
                        <FormattedMessage id='LIVES_IN' /> <FormattedMessage id='IN_CITY' />
                        &nbsp;
                        <Link
                            to={`/users_directory/?county=${fromGlobalId(county.id).id}`}
                            className={classnames(styles.link, styles.underline)}
                        >
                            {county.name}
                        </Link>
                    </div>
                </HideForVendor>
            ) : null}
            {weddingDate ? (
                <>
                    <div className={styles.sectionTitle}>
                        <FormattedMessage id='WEDDING_INFO' />
                    </div>
                    <div className={styles.dateJoined}>
                        <AuthorSVGIcon src={heartIcon} />
                        {new Date(weddingDate) > new Date() ? (
                            <FormattedMessage id='WEDDING_WILL_BE' />
                        ) : (
                            <FormattedMessage id='WEDDING_HAS_BEEN' />
                        )}
                        &nbsp;
                        <FormattedDate value={new Date(weddingDate)} />
                    </div>
                    <div className={styles.weddingDaysTill}>
                        {new Date(weddingDate) > new Date() ? (
                            <FormattedMessage
                                id='DAYS_TO_WEDDING'
                                values={{
                                    days: <div className={styles.days}>{daysBetween(new Date(weddingDate))}</div>,
                                }}
                            />
                        ) : (
                            <FormattedMessage
                                id='DAYS_FROM_WEDDING'
                                values={{
                                    days: <div className={styles.days}>{daysBetween(new Date(weddingDate))}</div>,
                                }}
                            />
                        )}
                    </div>
                </>
            ) : null}
        </React.Fragment>
    );
}

export default Styled(defaultStyles)(UserInformation);
